import $ from 'jquery';

var IS_DEVELOPMENT = false;
var win = $(window);

function initDepoimentos() {
  new Swiper('.swiper-depoimentos', {
    slidesPerView: 3,
    // init: false,
    // spaceBetween: 50,
    pagination: {
      el: '.swiper-depoimentos .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      700: {
        slidesPerView: 2,
      },
      480: {
        slidesPerView: 1,
      }
    }
  });
}

function initHoraDaTroca() {
  new Swiper('.swiper-horadatroca', {
    slidesPerView: 3,
    pagination: {
      el: '.swiper-horadatroca .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      800: {
        slidesPerView: 2,
      },
      480: {
        slidesPerView: 1,
      }
    }
  });
}

function initZigueZague() {
  var elZigueZague = $('.swiper-zigue-zague');
  var elZigueZaguePagination = $('.swiper-zigue-zague .swiper-pagination');
  var swpZigueZague = null;

  var dynamicZigueZague = () => {
    let winWidth = win.width();
    let widthPoint = 800;

    if(winWidth >= widthPoint) {
      // Destruir swiper
      if(swpZigueZague) {
        try { swpZigueZague.destroy(); } catch(e) {}
        swpZigueZague = null;
      }
      elZigueZague.addClass('swiper-container-disabled');
    } else {
      // Criar swiper
      if(!swpZigueZague) {
        swpZigueZague = new Swiper('.swiper-zigue-zague', {
          slidesPerView: 1,
          // spaceBetween: 20,
          pagination: {
            el: elZigueZaguePagination,
            clickable: true,
          }
        });
      }
      elZigueZague.removeClass('swiper-container-disabled');
    }

  }
  win.on('resize', dynamicZigueZague);
  dynamicZigueZague();
}

export default function(_IS_DEVELOPMENT) {
  IS_DEVELOPMENT = _IS_DEVELOPMENT;
  
  $(document).ready(function() {
    initDepoimentos();
    initHoraDaTroca();
    initZigueZague();
  });
};
